import * as types from './types'

export const fetchReport = (payload) => ({
  type: types.FETCH_REPORT,
  payload,
})

export const fetchReportFulfilled = ({ report, infoMessage, receivedAt }) => ({
  type: types.FETCH_REPORT_FULFILLED,
  payload: {
    report: report ?? null,
    infoMessage: infoMessage ?? '',
    receivedAt: receivedAt ?? null,
  },
})

export const fetchReportError = (error) => ({
  type: types.FETCH_REPORT_ERROR,
  payload: error ?? 'Unable to load emissions data.',
})

export const requestDownload = (payload) => ({
  type: types.REQUEST_DOWNLOAD,
  payload,
})

export const requestDownloadFulfilled = () => ({
  type: types.REQUEST_DOWNLOAD_FULFILLED,
})

export const requestDownloadError = (error) => ({
  type: types.REQUEST_DOWNLOAD_ERROR,
  payload: error ?? 'Unable to download emissions report.',
})

export default {
  fetchReport,
  fetchReportFulfilled,
  fetchReportError,
  requestDownload,
  requestDownloadFulfilled,
  requestDownloadError,
}
